import { api } from "./api";
import * as FileSystem from "expo-file-system";
import { Platform } from "react-native";
import axios from "axios";

export const getDivestimentHeaderStatus = () => {
  return api
    .get(`v1/disinvestment_header_status`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error(error);
    });
};

export const getDisinvestmentHeader = (header_id: string) => {
  return api
    .get(`v1/disinvestment_header/${header_id}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error(error);
    });
};

export const getDivestmentList = async (
  supplier_id: number,
  searchStatus?: string,
  searchInitialDate?: string,
  searchFinalDate?: string,
  offset?: string | number,
  limit?: string | number
) => {
  let url = `v1/disinvestment_status?supplier_id=${supplier_id}`;
  if (searchStatus) url = url + `&status=${searchStatus}`;
  if (searchInitialDate) url = url + `&initialDate=${searchInitialDate}`;
  if (searchFinalDate) url = url + `&finalDate=${searchFinalDate}`;
  if (offset) url = url + `&offset=${offset}`;
  if (limit) url = url + `&limit=${limit}`;
  try {
    const response = await api.get(url);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const postDivestimentHeader = (supplier_id: string) => {
  const body = { supplier_id };
  return api
    .post(`v1/disinvestment_header`, body)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error(error);
    });
};

export const getDivestimentSelectItens = (
  supplier_id: string,
  limit: number,
  offset?: number,
  searchTerm?: string
) => {
  return api
    .get(
      `v1/asset_list?supplier_id=${supplier_id}&limit=${limit}&offset=${offset}&filter=${searchTerm}`
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error(error);
    });
};

export const postDivestimentAddItem = (
  disinvestment_header_id: number,
  asset_numbers: []
) => {
  const body = { disinvestment_header_id, asset_numbers };
  return api
    .post(`v1/disinvestment_detail`, body)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error(error);
    });
};

export const deleteDivestimentItem = (disinvestment_item_id: string) => {
  return api
    .delete(`v1/disinvestment_detail/${disinvestment_item_id}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error(error);
    });
};

export const getDivestimentDetailList = (disinvestment_header_id: string) => {
  return api
    .get(`v1/disinvestment_detail_list/${disinvestment_header_id}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error(error);
    });
};

export const getDivestimentDetailItem = (disinvestment_detail_id: number) => {
  return api
    .get(`v1/disinvestment_detail/${disinvestment_detail_id}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error(error);
    });
};

export const postDivestimentRecDocuments = (
  disinvestment_order_detail_id: number,
  fileName: any
) => {
  const body = {
    disinvestment_order_detail_id: disinvestment_order_detail_id,
    fileName: fileName,
  };
  return api
    .post(`v1/disinvestment_detail/generate_signed_url`, body)
    .then((response) => {
      console.log("Upload file:", body, response);
      return response.data;
    })
    .catch((error) => {
      console.error("Upload file error:", error.response);
    });
};

export const getDivestimentRecDocuments = (
  disinvestment_order_detail_id: number
) => {
  const body = { disinvestment_order_detail_id: disinvestment_order_detail_id };
  return api
    .post(`v1/disinvestment_detail/get_signed_url`, body)
    .then((response) => {
      console.log(disinvestment_order_detail_id, response);
      return response.data;
    })
    .catch((error) => {
      console.error(body, error.response?.data);
    });
};

export const putDivestimentRecDocuments = async (
  presignedUrl: string,
  data: any
) => {
  if (Platform.OS !== "web") {
    const result = await FileSystem.uploadAsync(presignedUrl, data.uri, {
      fieldName: "file",
      httpMethod: "PUT",
      uploadType: FileSystem.FileSystemUploadType.BINARY_CONTENT,
    });
    return result;
  } else {
    try {
      const fileBlob = await fetch(data.uri).then((response) =>
        response.blob()
      );
      await axios.put(presignedUrl, fileBlob, {
        headers: {
          "Content-Type": data.file.type,
        },
      });
    } catch (error) {
      console.error(error);
    }
  }
};

export const putDivestimentRec = (
  disinvestment_detail_id: number,
  body: any
) => {
  return api
    .put(`v1/disinvestment_detail/${disinvestment_detail_id}`, body)
    .then((response) => {
      console.log("ok");
      return response.data;
    })
    .catch((error) => {
      console.error(error);
    });
};

export const getDivestimentSummary = (disinvestment_header_id: number) => {
  return api
    .get(`v1/disinvestment_header/${disinvestment_header_id}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error(error);
    });
};

export const putDivestimentFinish = (
  disinvestment_header_id: number,
  data: any
) => {
  console.log(disinvestment_header_id);
  return api
    .put(`v1/disinvestment_header/${disinvestment_header_id}`, data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error(error);
    });
};
